import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Typography,
  Box,
  Button,
  TablePagination,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControlLabel,
  Switch,
  Stack,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountBalance, Addchart, Delete, Edit, ExpandLess, MoreHoriz, PersonAdd, RestoreFromTrash } from '@mui/icons-material';
import CustomSnackBar from './CustomSnackBar';
import API from '../services/api';
import { useAuth } from '../auth/AuthProvider';
import { hasPerm } from '../auth/permissions';

function CustomTable({
  suppliers,
  loading,
  handleOpen,
  handleOpen2,
  handleOpen3,
  setSupplier_id,
  refresh,
}) {
  const [openRow, setOpenRow] = useState(null);
  const navigate = useNavigate();
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackSeverity, setSnackSeverity] = useState('info');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [objectiveModalOpen, setObjectiveModalOpen] = useState(false);
  const [objectiveSupplier, setObjectiveSupplier] = useState(null);
  const [objectiveData, setObjectiveData] = useState(null);
  const [earlyPaymentOpen, setEarlyPaymentOpen] = useState(false);
  const [earlyPaymentSupplier, setEarlyPaymentSupplier] = useState(null);
  const [earlyPaymentForm, setEarlyPaymentForm] = useState({
    id: null,
    datePeriod: '',
    percent: '',
    dueDateInvoice: true,
  });
  const formatMoney = (v) => new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(Number(v || 0));
  const { permissions, isSuperuser } = useAuth();
  const canManageObjective = isSuperuser || hasPerm(permissions, 'manage_supplier');

  const handleSupplier = (id) => {
    setSupplier_id(id);
  };

  const handleEdit = (id) => {
    navigate(`/suppliers/edit-supplier/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Está seguro de eliminar este proveedor?')) {
      try {
        await API.patch(`/suppliers/${id}/`, { is_active: false });
        setOpenSnack(true);
        setSnackMessage('¡Desactivado con éxito!');
        setSnackSeverity('success');
        refresh?.();
      } catch (error) {
        console.log(error);
        setOpenSnack(true);
        setSnackMessage('Intente de nuevo');
        setSnackSeverity('error');
      }
    }
  };

  const handleRestore = async (id) => {
    try {
      await API.patch(`/suppliers/${id}/`, { is_active: true });
      setOpenSnack(true);
      setSnackMessage('¡Restaurado con éxito!');
      setSnackSeverity('success');
      refresh?.();
    } catch (error) {
      console.log(error);
      setOpenSnack(true);
      setSnackMessage('Intente de nuevo');
      setSnackSeverity('error');
    }
  };

  const handleHardDelete = async (id) => {
    if (window.confirm('¿Eliminar permanentemente este proveedor?')) {
      try {
        await API.delete(`/suppliers/${id}/`);
        setOpenSnack(true);
        setSnackMessage('¡Eliminado permanentemente!');
        setSnackSeverity('success');
        refresh?.();
      } catch (error) {
        console.log(error);
        setOpenSnack(true);
        setSnackMessage('Intente de nuevo');
        setSnackSeverity('error');
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleObjectiveModal = (row) => {
    setObjectiveSupplier(row.id);
    setObjectiveData(row.current_objective || null);
    setObjectiveModalOpen(true);
  };

  const openEarlyPaymentModal = (supplierId, payment) => {
    setEarlyPaymentSupplier(supplierId);
    setEarlyPaymentForm({
      id: payment?.id ?? null,
      datePeriod: payment?.datePeriod ?? '',
      percent: payment?.percent ?? '',
      dueDateInvoice: payment?.dueDateInvoice ?? true,
    });
    setEarlyPaymentOpen(true);
  };

  const closeEarlyPaymentModal = () => {
    setEarlyPaymentOpen(false);
    setEarlyPaymentSupplier(null);
    setEarlyPaymentForm({
      id: null,
      datePeriod: '',
      percent: '',
      dueDateInvoice: true,
    });
  };

  const handleEarlyPaymentField = (field) => (e) => {
    const value = field === 'dueDateInvoice' ? e.target.checked : e.target.value;
    setEarlyPaymentForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleEarlyPaymentSave = async () => {
    if (!earlyPaymentForm.id || !earlyPaymentSupplier) return;
    const payload = {
      datePeriod: earlyPaymentForm.datePeriod,
      percent: earlyPaymentForm.percent,
      dueDateInvoice: !!earlyPaymentForm.dueDateInvoice,
      supplier: earlyPaymentSupplier,
    };
    try {
      await API.patch(`early-payment/${earlyPaymentForm.id}/`, payload);
      setOpenSnack(true);
      setSnackMessage('Pronto pago actualizado');
      setSnackSeverity('success');
      closeEarlyPaymentModal();
      refresh?.();
    } catch (error) {
      console.log(error);
      setOpenSnack(true);
      setSnackMessage('No se pudo actualizar el pronto pago');
      setSnackSeverity('error');
    }
  };

  const handleEarlyPaymentDelete = async (payment, supplierId) => {
    if (!payment?.id) return;
    if (!window.confirm('¿Eliminar pronto pago?')) return;
    try {
      await API.patch(`early-payment/${payment.id}/`, {
        is_active: false,
        supplier: supplierId,
      });
      setOpenSnack(true);
      setSnackMessage('Pronto pago eliminado');
      setSnackSeverity('success');
      refresh?.();
    } catch (error) {
      console.log(error);
      setOpenSnack(true);
      setSnackMessage('No se pudo eliminar el pronto pago');
      setSnackSeverity('error');
    }
  };

  return (
    <Box width={'95%'} padding={2}>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="medium" aria-label="collapsible table">
          <TableHead sx={{ backgroundColor: '#10173c', color: 'white' }}>
            <TableRow>
              <TableCell sx={{ color: 'white' }}>#</TableCell>
              <TableCell sx={{ color: 'white' }}>Nombre razón social</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}>Nombre</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}>Nit</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}>Límite de crédito</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}>Tipo proveedor</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}>Días de crédito</TableCell>
              <TableCell align="right" sx={{ color: 'white' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7}>Cargando...</TableCell>
              </TableRow>
            ) : (
              suppliers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <React.Fragment key={row.id}>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      onClick={() => {
                        setOpenRow(openRow === row.id ? null : row.id);
                        handleSupplier(row.id);
                      }}
                    >
                      <TableCell>
                        <Box
                          sx={{
                            display: 'inline-block',
                            minWidth: '24px',
                            px: 1,
                            py: '2px',
                            backgroundColor: '#EEF1F6',
                            color: '#2B3E4D',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            fontFamily: 'Segoe UI, Roboto, sans-serif',
                            textAlign: 'center',
                            boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.06)',
                          }}
                        >
                          {index + 1}
                        </Box>
                      </TableCell>
                      <TableCell component="th" scope="row">{row.legalName}</TableCell>
                      <TableCell align="right">{row.companyName}</TableCell>
                      <TableCell align="right">{row.taxNumber}</TableCell>
                      <TableCell align="right">
                        {new Intl.NumberFormat('es-GT', {
                          style: 'currency',
                          currency: 'GTQ',
                        }).format(row.creditLimit)}
                      </TableCell>
                      <TableCell align="right">{row.isCredit ? 'Crédito' : 'Contado'}</TableCell>
                      <TableCell align="right">{row.creditPeriod} días</TableCell>
                      <TableCell align="right">
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenRow(openRow === row.id ? null : row.id);
                            handleSupplier(row.id);
                          }}
                        >
                          {openRow === row.id ? <ExpandLess sx={{ color: 'black' }} /> : <MoreHoriz sx={{ color: 'black' }} />}
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                        <Collapse in={openRow === row.id} timeout="auto" unmountOnExit>
                          <Box sx={{ margin: 1 }}>
                            {row.is_active ? (
                              <>
                                <Button
                                  variant="contained"
                                  startIcon={<Edit size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginRight: '5px' }}
                                  color="info"
                                  onClick={() => handleEdit(row.id)}
                                >
                                  Editar
                                </Button>
                                <Button
                                  variant="contained"
                                  startIcon={<Delete size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginRight: '5px' }}
                                  color="error"
                                  onClick={() => handleDelete(row.id)}
                                >
                                  Desactivar
                                </Button>
                                <Button
                                  variant="contained"
                                  startIcon={<Addchart size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginRight: '5px' }}
                                  color="success"
                                  onClick={() => handleOpen(row.id)}
                                >
                                  Agregar Pronto Pago
                                </Button>
                                <Button
                                  variant="contained"
                                  startIcon={<PersonAdd size={20} color="inherit" />}
                                  sx={{ fontSize: '10px' }}
                                  color="primary"
                                  onClick={() => handleOpen2(row.id)}
                                >
                                  Agregar Ejecutivo
                                </Button>
                                <Button
                                  variant="contained"
                                  startIcon={<AccountBalance size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginLeft: '5px' }}
                                  color="warning"
                                  onClick={() => handleOpen3(row.id)}
                                >
                                  Agregar Cuenta Bancaria
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  variant="contained"
                                  startIcon={<RestoreFromTrash size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginRight: '5px' }}
                                  color="primary"
                                  onClick={() => handleRestore(row.id)}
                                >
                                  Restaurar
                                </Button>
                                <Button
                                  variant="contained"
                                  startIcon={<Delete size={20} color="inherit" />}
                                  sx={{ fontSize: '10px', marginRight: '5px' }}
                                  color="error"
                                  onClick={() => handleHardDelete(row.id)}
                                >
                                  Eliminar
                                </Button>
                              </>
                            )}
                            <Typography variant="h6" component="div">
                              Información adicional
                            </Typography>
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primary="Ejecutivos"
                                  secondary={
                                    row.executives?.length === 0
                                      ? 'Sin ejecutivos'
                                      : row.executives?.map((e) => `${e.name} ${e.lastName} - Tel: ${e.phone} (${e.role})`).join(', ')
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primary="Cuentas bancarias"
                                  secondary={
                                    row.bank_accounts?.length === 0
                                      ? 'Sin cuentas bancarias'
                                      : row.bank_accounts?.map((e) => `${e.bankName}: ${e.accNumber} (${e.accType})`).join(', ')
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText primary="Dirección" secondary={row.address} />
                              </ListItem>
                              <ListItem>
                                <ListItemText primary="Teléfono" secondary={row.phone} />
                              </ListItem>
                              <ListItem
                                secondaryAction={canManageObjective && (
                                  <Button variant="outlined" size="small" onClick={() => handleObjectiveModal(row)}>
                                    Configurar objetivo
                                  </Button>
                                )}
                              >
                                <ListItemText
                                  primary="Objetivo de compra"
                                  secondary={(() => {
                                    const obj = row.current_objective || row.purchase_objective || row.purchaseObjective || row.objective;
                                    if (!obj) return 'Sin objetivo configurado';
                                    const period = obj.start_date && obj.end_date ? ` (${obj.start_date} -> ${obj.end_date})` : '';
                                    const typeLabel = obj.objective_type || '';
                                    const target = obj.target_amount ?? obj.metaMes ?? obj.original_target_amount ?? 0;
                                    return `${formatMoney(target)}${period}${typeLabel ? ` • ${typeLabel}` : ''}`;
                                  })()}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primary="Pronto pago"
                                  secondary={(row.early_payments || []).filter(ep => ep?.is_active !== false).length === 0 ? 'Sin pronto pago' : null}
                                />

                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                  {(row.early_payments || []).filter(ep => ep?.is_active !== false).map((e, index) => (
                                    <Chip
                                      key={e?.id || index}
                                      label={`${e.percent}% -> ${e.datePeriod} días`}
                                      color="primary"
                                      size="small"
                                      icon={<Edit fontSize="small" />}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        openEarlyPaymentModal(row.id, e);
                                      }}
                                      onDelete={(event) => {
                                        event.stopPropagation();
                                        handleEarlyPaymentDelete(e, row.id);
                                      }}
                                      deleteIcon={<Delete fontSize="small" />}
                                    />
                                  ))}
                                </Box>
                              </ListItem>
                            </List>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
            
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={suppliers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Dialog open={earlyPaymentOpen} onClose={closeEarlyPaymentModal} fullWidth maxWidth="xs">
        <DialogTitle>Editar pronto pago</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="Periodo (dias)"
              type="number"
              value={earlyPaymentForm.datePeriod}
              onChange={handleEarlyPaymentField('datePeriod')}
              fullWidth
            />
            <TextField
              label="Porcentaje"
              type="number"
              value={earlyPaymentForm.percent}
              onChange={handleEarlyPaymentField('percent')}
              fullWidth
            />
            <FormControlLabel
              control={
                <Switch
                  checked={!!earlyPaymentForm.dueDateInvoice}
                  onChange={handleEarlyPaymentField('dueDateInvoice')}
                />
              }
              label="Fecha factura"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEarlyPaymentModal}>Cancelar</Button>
          <Button variant="contained" onClick={handleEarlyPaymentSave}>Guardar</Button>
        </DialogActions>
      </Dialog>
      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
      )}
      <PurchaseObjectiveModal
        open={objectiveModalOpen}
        onClose={() => setObjectiveModalOpen(false)}
        supplierId={objectiveSupplier}
        currentObjective={objectiveData}
        onSaved={refresh}
      />
    </Box>
  );
}

function PurchaseObjectiveModal({ open, onClose, supplierId, currentObjective, onSaved }) {
  const [form, setForm] = useState({
    objective_type_id: '',
    start_date: '',
    end_date: '',
    target_amount: '',
  });
  const [objectiveTypes, setObjectiveTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);

  useEffect(() => {
    if (currentObjective) {
      setForm({
        objective_type_id: currentObjective.objective_type_id || '',
        start_date: currentObjective.start_date || '',
        end_date: currentObjective.end_date || '',
        target_amount: currentObjective.target_amount || currentObjective.original_target_amount || '',
      });
    } else {
      setForm({
        objective_type_id: '',
        start_date: '',
        end_date: '',
        target_amount: '',
      });
    }
  }, [currentObjective, open]);

  useEffect(() => {
    const loadTypes = async () => {
      setLoadingTypes(true);
      try {
        const res = await API.get('catalogs/objective-types/');
        const data = Array.isArray(res.data) ? res.data : (res.data?.results || []);
        setObjectiveTypes(data);
        if (!form.objective_type_id && data.length) {
          setForm((prev) => ({ ...prev, objective_type_id: data[0].id }));
        }
      } catch (e) {
        console.error('No se pudieron cargar tipos de objetivo', e);
        setObjectiveTypes([]);
      } finally {
        setLoadingTypes(false);
      }
    };
    if (open) loadTypes();
  }, [open]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (!supplierId) return;
    const payload = {
      ...form,
      target_amount: Number(form.target_amount || 0),
      supplier: supplierId,
      objective_type: form.objective_type_id || form.objective_type,
    };
    try {
      if (currentObjective?.id) {
        await API.put(`purchase-objectives/${currentObjective.id}/`, payload);
      } else {
        await API.post('purchase-objectives/', payload);
      }
      onSaved?.();
      onClose?.();
    } catch (error) {
      console.error('Error guardando objetivo', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Configurar objetivo de compra</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            select
            label="Tipo de objetivo"
            value={form.objective_type_id}
            onChange={handleChange('objective_type_id')}
            fullWidth
            disabled={loadingTypes || objectiveTypes.length === 0}
          >
            {objectiveTypes.map((ot) => (
              <MenuItem key={ot.id} value={ot.id}>{ot.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="Fecha inicio"
            type="date"
            value={form.start_date}
            onChange={handleChange('start_date')}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="Fecha fin"
            type="date"
            value={form.end_date}
            onChange={handleChange('end_date')}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="Meta"
            type="number"
            value={form.target_amount}
            onChange={handleChange('target_amount')}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        {currentObjective?.id && (
          <Button color="error" onClick={async () => {
            try {
              await API.delete(`purchase-objectives/${currentObjective.id}/`);
              onSaved?.();
              onClose?.();
            } catch (err) {
              console.error('No se pudo eliminar el objetivo', err);
            }
          }}>Eliminar</Button>
        )}
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSubmit}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomTable;
